import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OtpInputComponent } from './otp-input.component';

@NgModule({
  declarations: [OtpInputComponent],
  imports: [CommonModule, FormsModule],
  exports: [OtpInputComponent]
})
export class OtpInputModule {}
